import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "./PdfModal.css";


pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function PdfModal({ fileUrl, onClose }) {
  const [numPages, setNumPages] = useState(null);

  if (!fileUrl) return null;

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <div className="pdf-modal-overlay">
      <div className="pdf-modal">
        <button className="pdf-close" onClick={onClose}>✖</button>
        <div className="pdf-document-container">
          <Document
            file={fileUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            className="pdf-document"
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={600}
                renderTextLayer={false}       // 🚀 Désactive le rendu texte
              />
            ))}
          </Document>
        </div>
      </div>
    </div>
  );
}
